<script setup lang="ts">
import { ArrowRight, BookOpen, Compass, Wrench } from "@lucide/vue";
import { computed } from "vue";
import { RouterLink, useRoute } from "vue-router";

const route = useRoute();
const page = computed(() => {
  const path = route.path.replace(/\/$/, "");
  if (path === "/en/library") return { eyebrow: "Library", title: "Practical knowledge", description: "Reviewed guides, historical VPS notes, and verified service entries for operators.", icon: BookOpen, links: [["Linux and systems", "/library?section=knowledge&topic=linux"], ["Networking and security", "/library?section=knowledge&topic=network"], ["Troubleshooting", "/library?section=knowledge&topic=troubleshoot"]] };
  if (path === "/en/tools") return { eyebrow: "Tools", title: "Tools and resources", description: "Small browser-local utilities plus carefully checked official entry points.", icon: Wrench, links: [["CIDR subnet planner", "/tools/cidr"], ["JSON / YAML workbench", "/tools/json-yaml"], ["Time and timezone converter", "/tools/time"]] };
  if (path === "/en/about") return { eyebrow: "About VPScope", title: "Evidence before confidence", description: "VPScope makes editorial status, source boundaries, and review context visible.", icon: Compass, links: [["Read the Chinese editorial policy", "/about#editorial-policy"], ["Browse the public library", "/library"], ["Open tools and resources", "/tools"]] };
  return { eyebrow: "VPScope · Practical server knowledge", title: "Find a verifiable way forward", description: "Guides for deployment, troubleshooting, security, and infrastructure choices. Each page states assumptions, checks, and rollback paths.", icon: Compass, links: [["Browse the library", "/en/library"], ["Open tools and resources", "/en/tools"], ["About the editorial method", "/en/about"]] };
});
</script>

<template>
  <header class="page-head english-head">
    <div class="page-width page-head-grid">
      <div><span>{{ page.eyebrow }}</span><h1>{{ page.title }}</h1><p>{{ page.description }}</p></div>
      <component :is="page.icon" :size="34" aria-hidden="true" />
    </div>
  </header>
  <section class="policy-band english-band">
    <div class="page-width english-intro">
      <p>English entry pages cover the core site surfaces. Article content remains in Chinese unless a genuine English edition exists.</p>
      <nav aria-label="English VPScope navigation">
        <RouterLink v-for="([label, to]) in page.links" :key="to" :to="to"><span>{{ label }}</span><ArrowRight :size="17" /></RouterLink>
      </nav>
    </div>
  </section>
</template>
